module.exports = __webpack_public_path__ + "img/ZJ4937.20222a24.png";